import React from 'react';
import { XIcon } from 'lucide-react';
export function AgitationSection() {
  return <section className="w-full bg-beige py-12 md:py-20 px-4" data-id="element-1">
      <div className="max-w-[680px] mx-auto font-body" data-id="element-2">
        <p className="text-lg md:text-xl text-dark-gray mb-6" data-id="element-3">
          La mayoría de las guías de crochet te enseñan los puntos.
        </p>

        <p className="font-bold text-xl md:text-2xl text-dark-gray mb-8" data-id="element-4">
          Pero nadie te dice:
        </p>

        <ul className="space-y-4 mb-10" data-id="element-5">
          <li className="flex items-start gap-3" data-id="element-6">
            <XIcon className="w-6 h-6 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-7" />
            <span className="text-dark-gray text-base md:text-lg" data-id="element-8">
              <strong className="font-bold" data-id="element-9">Qué materiales comprar</strong> (y
              qué evitar para no frustrarte)
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-10">
            <XIcon className="w-6 h-6 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-11" />
            <span className="text-dark-gray text-base md:text-lg" data-id="element-12">
              <strong className="font-bold" data-id="element-13">Cómo medirte</strong> para que te
              quede bien (no "más o menos")
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-14">
            <XIcon className="w-6 h-6 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-15" />
            <span className="text-dark-gray text-base md:text-lg" data-id="element-16">
              <strong className="font-bold" data-id="element-17">Cómo avanzar hora a hora</strong>{' '}
              sin quedarte estancada
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-18">
            <XIcon className="w-6 h-6 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-19" />
            <span className="text-dark-gray text-base md:text-lg" data-id="element-20">
              <strong className="font-bold" data-id="element-21">Qué hacer si algo salió mal</strong>{' '}
              (sin deshacer todo)
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-22">
            <XIcon className="w-6 h-6 text-pink-dark flex-shrink-0 mt-0.5" data-id="element-23" />
            <span className="text-dark-gray text-base md:text-lg" data-id="element-24">
              <strong className="font-bold" data-id="element-25">Cómo darle ese look prolijo</strong>{' '}
              que parece de tienda
            </span>
          </li>
        </ul>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border-l-4 border-pink-dark" data-id="element-26">
          <p className="font-heading font-bold text-xl md:text-2xl text-dark-gray" data-id="element-27">
            Eso es exactamente lo que resuelven los 5 bonos que te regalo hoy.
          </p>
        </div>
      </div>
    </section>;
}